export default __webpack_public_path__ + "static/media/icons8-crm.94c4aa98.svg";